import { ChangeDetectorRef, NgZone, Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

@Pipe({
  name: 'notificationDate',
  pure: false, // VERY IMPORTANT: allows live updates
})
export class NotificationDatePipe implements PipeTransform {
  private lastValue: string = '';
  private timer: any;

  constructor(private ref: ChangeDetectorRef, private ngZone: NgZone) {}
  
  transform(value: Date | string): unknown {
    this.clearTimer();
    if (!value) return '';

    const update = () => {
      const now = dayjs();
      const input = dayjs(value);
      const diffMinutes = now.diff(input, 'minute');
      const diffHours = now.diff(input, 'hour');
      const diffDays = now.diff(input, 'day');

      if (diffMinutes < 1) this.lastValue = 'just now';
      else if (diffMinutes < 60) this.lastValue = `${diffMinutes}m ago`;
      else if (diffHours < 24) this.lastValue = `${diffHours}h ago`;
      else if (diffDays === 1) this.lastValue = 'Yesterday';
      else if (diffDays <= 6) this.lastValue = `${diffDays} days ago`;
      else if (diffDays <= 13) this.lastValue = `Last week`;
      else this.lastValue = input.format('DD MMM YYYY');
    };

    update();

    this.ngZone.runOutsideAngular(() => {
      this.timer = setInterval(() => {
        update();
        this.ref.markForCheck(); // Trigger change detection
      }, 60 * 1000); // Update every minute
    });

    return this.lastValue;
  }

  private clearTimer() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  ngOnDestroy() {
    this.clearTimer();
  }

}
